import { dataMedicalKitSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMedicalKitSolid = /*#__PURE__*/createIcon(dataMedicalKitSolid)
export default IconMedicalKitSolid
